import React, { useEffect, useState } from "react";
import {
  Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, MenuItem, TextField, Typography,
} from "@mui/material";
import { crearAsiento, fmtFecha, fmtMoney } from "../services/egresosService";

const fieldSx = {
  "& .MuiInputBase-root": { minHeight: 32 },
  "& .MuiInputBase-input": { py: "5px", fontSize: "0.8rem" },
  "& .MuiInputLabel-root": { fontSize: "0.8rem" },
};
const MESES = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

const inicial = () => ({ debe: "", haber: "", bolivianos: "", dolares: "", mes: new Date().getMonth() + 1, year: new Date().getFullYear(), observacion: "" });

// Alta de un asiento contable manual (espejo de co_cg_asiento/busqueda.php + Guarda_asiento.php).
export default function AsientoDialog({ open, onClose, cuentas }) {
  const [f, setF] = useState(inicial());
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");
  const [guardado, setGuardado] = useState(null);

  useEffect(() => {
    if (open) { setF(inicial()); setError(""); setGuardado(null); }
  }, [open]);

  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const anios = Array.from({ length: new Date().getFullYear() + 2 - 2008 }, (_, i) => 2008 + i);

  const guardar = async () => {
    setGuardando(true);
    setError("");
    try {
      const { data } = await crearAsiento(f);
      setGuardado(data);
      setF(inicial());
    } catch (e) {
      setError(e?.response?.data?.error || "No se pudo guardar el asiento.");
    } finally {
      setGuardando(false);
    }
  };

  const selectCuenta = (k, label) => (
    <TextField select fullWidth size="small" label={label} value={f[k]} onChange={set(k)} sx={fieldSx}>
      {cuentas.map((c) => <MenuItem key={c.cuenta} value={c.cuenta}>{c.concepto}</MenuItem>)}
    </TextField>
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ py: 1, fontSize: "0.95rem", fontWeight: 900 }}>Insertar asiento contable</DialogTitle>
      <DialogContent dividers>
        {error && <Alert severity="error" sx={{ mb: 1, py: 0 }}>{error}</Alert>}
        {guardado && (
          <Alert severity="success" sx={{ mb: 1, py: 0 }}>
            Asiento {guardado.id} guardado ({fmtFecha(guardado.fecha)}): debe {guardado.debe} / haber {guardado.haber} — Bs {fmtMoney(guardado.bolivianos)} · $us {fmtMoney(guardado.dolares)}.
          </Alert>
        )}
        <Grid container spacing={1}>
          <Grid size={12}>{selectCuenta("debe", "Cuenta al debe")}</Grid>
          <Grid size={12}>{selectCuenta("haber", "Cuenta al haber")}</Grid>
          <Grid size={6}><TextField fullWidth size="small" label="Monto en Bolivianos" value={f.bolivianos} onChange={set("bolivianos")} sx={fieldSx} /></Grid>
          <Grid size={6}><TextField fullWidth size="small" label="Monto en Dólares" value={f.dolares} onChange={set("dolares")} sx={fieldSx} /></Grid>
          <Grid size={6}>
            <TextField select fullWidth size="small" label="Mes" value={f.mes} onChange={set("mes")} sx={fieldSx}>
              {MESES.map((m, i) => <MenuItem key={m} value={i + 1}>{m}</MenuItem>)}
            </TextField>
          </Grid>
          <Grid size={6}>
            <TextField select fullWidth size="small" label="Año" value={f.year} onChange={set("year")} sx={fieldSx}>
              {anios.map((a) => <MenuItem key={a} value={a}>{a}</MenuItem>)}
            </TextField>
          </Grid>
          <Grid size={12}><TextField fullWidth size="small" label="Observaciones" value={f.observacion} onChange={set("observacion")} sx={fieldSx} /></Grid>
        </Grid>
        <Typography sx={{ fontSize: 11, mt: 1 }} color="text.secondary">El asiento queda registrado con fecha del día 1 del mes elegido.</Typography>
      </DialogContent>
      <DialogActions sx={{ p: 0.75 }}>
        <Button size="small" onClick={onClose}>Cerrar</Button>
        <Button size="small" variant="contained" onClick={guardar} disabled={guardando || !f.debe || !f.haber}>
          {guardando ? <CircularProgress size={16} color="inherit" /> : "Guardar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
